import React from "react";
import FullLogo from "../assets/Full logo.png";
import { useNavigate } from "react-router-dom";
import UseAuth from "../utils/use-auth";
import { UserType } from "../types/user-types";

const Navbar = () => {
  const { user, HandleUserLogOut } = UseAuth();
  const navigate = useNavigate();

  return (
    <nav className="w-full bg-[#1B2B5E] border-b border-white/10 sticky top-0 z-40">
      <div className="flex justify-between items-center max-w-[1240px] w-[95%] py-3 md:py-4 mx-auto">
        {/* Logo */}
        <img
          className="h-9 sm:h-10 md:h-12 object-contain cursor-pointer"
          src={FullLogo}
          alt="Martech Mastery"
          onClick={() => navigate("/")}
        />

        {/* Actions */}
        {user?.id ? (
          <div className="flex items-center gap-2 sm:gap-3">
            {user?.userType === UserType.ADMIN && (
              <button
                className="px-4 py-2 text-xs sm:text-sm text-white font-semibold rounded-lg whitespace-nowrap"
                style={{ background: "linear-gradient(135deg, #F05A22, #E8407A)" }}
                onClick={() => navigate("/dashboard")}
              >
                Admin Dashboard
              </button>
            )}
            <button
              className="px-4 py-2 text-xs sm:text-sm text-white/80 rounded-lg border border-white/20 hover:bg-white/10 hover:text-white font-medium"
              onClick={HandleUserLogOut}
            >
              Logout
            </button>
          </div>
        ) : (
          <button
            className="px-5 py-2 text-sm text-white font-semibold rounded-lg"
            style={{ background: "linear-gradient(135deg, #F05A22, #E8407A)" }}
            onClick={() => navigate("/login")}
          >
            Sign in
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
